import React from "react";
import InstallerShell from "@/components/installer/InstallerShell";
import TodoWorkspace from "@/components/todo/TodoWorkspace";

/**
 * DEV-026 · Field Resource To-do workspace.
 *
 * Same shared component + backend as Sales — a to-do IS an ad-hoc
 * task. Adds parity for the Field Resource sidebar without
 * duplicating any record.
 */
export default function InstallerTodo() {
    return (
        <InstallerShell>
            <TodoWorkspace
                eyebrow="FIELD PORTAL"
                subtitle="Your ad-hoc to-do list. New to-dos also appear in Tasks."
                testidPrefix="installer-todo"
            />
        </InstallerShell>
    );
}
